
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'testi',
	'visualizationSlideoutTitle': 'Visualisoinnit',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Anna luku',
	'maxValuePlaceholder': 'Anna luku',
	'customRangeErrorMessage': 'Arvon on oltava luku',
	'propFillColor': 'Täyttöväri',
	'propBorderColor': 'Reunuksen väri',
	'propColorPalette': 'Nykyinen väripaletti',
	'propColorPaletteChangeLabel': 'Vaihda väripaletti',
	'propNewColorPaletteLabel': 'Luo mukautettu väripaletti',
	'propNewHeatPaletteLabel': 'Luo mukautettu lämpökaaviopaletti',
	'propDonutRadius': 'Renkaan säde',
	'showTitleLabel': 'Näytä otsikko',
	'titleTypeLabel': 'Otsikon laji',
	'smartTitleLabel': 'Erikoisotsikko',
	'customTitleLabel': 'Mukautettu otsikko',
	'noTitleLabel': 'Ei otsikkoa',
	'propHeatScalePalette': 'Nykyinen lämpökaaviopaletti',
	'propHeatPaletteChangeLabel': 'Vaihda lämpökaaviopalettia',
	'propMaintainAxisScales': 'Säilytä akselin mittakaava',
	'propLineAndSymbolColor': 'Viivan ja symbolin väri',
	'propLineAndSymbolPalette': 'Viivan ja symbolin väripaletti',
	'propElementColor': 'Elementin väri',
	'propColumnColor': 'Pylväskaavion väri',
	'propColumnPalette': 'Pylväskaavion väripaletti',
	'propColumnHeatPalette': 'Pylväskaavion lämpökaaviopaletti',
	'propBarColor': 'Palkin väri',
	'propGoalColor': 'Kohteen väri',
	'propToColor': 'Lopetusväri',
	'propFromColor': 'Aloitusväri',
	'propNumberValidationErrorMessageId': 'Anna luku',
	'fontSizeAuto': 'Automaattinen',
	'propAutoBinCount': 'Ryhmien määrä',
	'propAutoBinToggle': 'Automaattinen ryhmittely',
	'tabName_general': 'Yleiset',
	'tabName_visDetails': 'Tiedot',
	'tabName_animation': 'Animaatio',
	'tabName_mediaDetails': 'Multimediasisällön tiedot',
	'tabName_webDetails': 'Web-sivun tiedot',
	'tabName_imageDetails': 'Kuvan tiedot',
	'tabName_visualization': 'Visualisointi',
	'tabName_text': 'Teksti',
	'sectionName_colorsAndThemes': 'Väri ja teemat',
	'sectionName_appearance': 'Ulkoasu',
	'sectionName_general': 'Yleiset',
	'sectionName_colorPalette': 'Väri',
	'sectionName_axis': 'Akseli',
	'sectionName_axis_label': 'Akseli',
	'sectionName_legend': 'Selite',
	'sectionName_chart': 'Kaavio',
	'sectionName_regionLayer': 'Aluetaso',
	'sectionName_pointLayer': 'Pistetaso',
	'sectionName_latLongLayer': 'Leveys - ja pituusastetaso',
	'sectionName_pathLayer': 'Polkutaso',
	'sectionName_xAxis': 'X-akseli',
	'sectionName_yAxis': 'Y-akseli',
	'sectionName_xAxis_title': 'X-akselin otsikko',
	'sectionName_yAxis_title': 'Y-akselin otsikko',
	'sectionName_xAxis_label': 'X-akselin nimiö',
	'sectionName_yAxis_label': 'Y-akselin nimiö',
	'sectionName_column_yAxis': 'Pylväskaavion Y-akseli',
	'sectionName_column_yAxis_label': 'Pylväskaavion Y-akselin nimiö',
	'sectionName_column_yAxis_title': 'Pylväskaavion Y-akselin otsikko',
	'sectionName_line_yAxis': 'Viivakaavion Y-akseli',
	'sectionName_line_yAxis_label': 'Viivakaavion Y-akselin nimiö',
	'sectionName_line_yAxis_title': 'Viivakaavion Y-akselin otsikko',
	'sectionName_title': 'Otsikko',
	'sectionName_dataValueLabels': 'Tietoarvojen nimiöt',
	'sectionName_style': 'Tyyli',
	'propTransparencyDescription': 'Tee objektista enemmän tai vähemmän läpinäkyvä. Kirjoita jokin arvo 0 - 100.',
	'smart_annotation_unauthorized': 'Huomautukset: luvaton käyttö',
	'smart_annotation_method': 'Huomautukset: menetelmä ei ole sallittu',
	'smart_annotation_media': 'Huomautukset: tallennusvälineen laji ei ole sallittu',
	'smart_annotation_input': 'Huomautukset: syöte ei kelpaa',
	'smart_annotation_internal': 'Huomautukset: sisäinen järjestelmävirhe',
	'smart_annotation_generic_error': 'Huomautukset: palveluvirhe',
	'smart_annotation_dialog_title': 'Oivallustoiminto',
	'smart_annotation_Show_Insights': 'Näytä näkemykset',
	'smart_annotation_Relationship': 'Suhde on',
	'forecast_enter_number': 'Anna luku väliltä ',
	'and': ' ja ',
	'smart_errors': 'Huomautusvirheet:',
	'smart_warnings': 'Huomautusvaroitukset:',
	'smart_annotation_insight_icon_title': 'Oivallustoiminto',
	'smart_annotations_toggle_on': 'Ota oivallustoiminto käyttöön',
	'smart_annotations_toggle_off': 'Poista oivallustoiminto käytöstä',
	'smart_annotation_toggle_on': 'Ota käyttöön',
	'smart_annotation_toggle_off': 'Poista käytöstä',
	'smart_annotation_insight_unavailable': 'Oivallustoiminto ei ole nyt käytettävissä',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Näkemykset eivät ole käytettävissä, kun käytössä on suodatin Alin % tai Ylin %',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Ennuste ei ole käytettävissä, kun käytössä on suodatin Alin % tai Ylin %',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Näkemykset eivät ole käytettävissä, kun käytössä on alimpien tai ylimpien suodatin ja kentässä on enemmän kuin yksi sarake',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Ennuste ei ole käytettävissä, kun käytössä on alimpien tai ylimpien suodatin ja kentässä on enemmän kuin yksi sarake',
	'forecast_title': 'Ennuste',
	'forecast_show': 'Näytä ennuste',
	'forecast_toggle_on': 'Ota ennuste käyttöön',
	'forecast_toggle_off': 'Poista ennuste käytöstä',
	'statDetailsPerspectiveTitle': 'Analyysi',
	'emptyStatDetailsPanel': 'Nykyiselle visualisoinnille ei ole käytettävissä lisäanalyysia.',
	'predict_errors': 'Analyysivirheet',
	'predict_warnings': 'Analyysivaroitukset',
	'fpd_invalid_data_source': 'Tähän tietolähteeseen ei ole liittyvää erikoismoduulia',
	'fpd_network_issue': 'Suoritettaessa analyysia tälle tietolähteelle on ilmennyt ongelma',
	'fpd_data_source_category': 'Erikoismoduuli puuttuu',
	'fpd_response_errors': 'Suositellun vaikuttimen virheet',
	'fpd_response_warnings': 'Suositellun vaikuttimen varoitukset',
	'catalyst_service_bad_request': 'Virheellinen pyyntö',
	'catalyst_service_unkown_Id': 'On löytynyt tuntematon pyynnön tunnus',
	'catalyst_service_internal_server_error': 'Sisäinen palvelinvirhe',
	'catalyst_service_generic_error': 'Catalyst-palveluvirhe',
	'catalyst_service_error': 'Tämä palvelu ei ole nyt käytettävissä',
	'propLegendPosition': 'Selitteen sijainti',
	'propLeft': 'Vasemmalla',
	'propRight': 'Oikealla',
	'propTop': 'Ylhäällä',
	'propBottom': 'Alhaalla',
	'propNone': 'Ei mitään',
	'propLegendDisplay': 'Näytä selite',
	'targetThicknessPlaceHolder': '%{min} - %{max}',
	'targetThicknessErrorMsg': 'Anna kokonaisluku %{min} - %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Vaikuttimet (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'valittu)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Palauta oletusarvot',
	'possibelKeyDriver_AddNewDrivers': 'Lisää enemmän vaikuttimia',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Voit lisätä enemmän vaikuttimia hakemalla',
	'possibleKeyDrivers_MaxPossibleReached': 'Voit lisätä vaikuttimia tai valita muita poistamalla joidenkin vaikuttimien valinnan',
	'possibleKeyDrivers_Recommended': 'Suositellut',
	'visRecommendedTypes': 'Suositellut visualisointityypit',
	'visRecommender_smartsfailure': 'Visualisointisuositukset eivät ole nyt käytettävissä',
	'visMore': 'Lisää...',
	'visMoreTooltip': 'Lisää visualisointeja',
	'visOtherTypes': 'Muut visualisointityypit',
	'visChange': 'Vaihda visualisointi',
	'automaticTypeCaption': 'Automaattinen',
	'propVisType': 'Visualisointityypit',
	'dlg_loading': 'Ladataan...',
	'snippetListChartCaption': 'Katkelmaluettelo',
	'convoClusterChartCaption': 'Keskusteluryväs',
	'areaChartCaption': 'Aluekaavio',
	'barChartCaption': 'Palkkikaavio',
	'columnChartCaption': 'Pylväskaavio',
	'stackedbarChartCaption': 'Pinottu palkki',
	'stackedcolumnChartCaption': 'Pinottu pylväs',
	'bubbleChartCaption': 'Kuplakaavio',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Vaikuttimien analyysi',
	'scatterChartCaption': 'Hajontakaavio',
	'lineChartCaption': 'Viivakaavio',
	'pointChartCaption': 'Pistekaavio',
	'heatChartCaption': 'Lämpökaavio',
	'bulletChartCaption': 'Tavoitearvokaavio',
	'waterfallChartCaption': 'Vesiputouskaavio',
	'radarChartCaption': 'Radar-kaavio',
	'boxplotChartCaption': 'Laatikkojanakaavio',
	'pieChartCaption': 'Ympyräkaavio',
	'mapChartCaption': 'Kartta',
	'radialBarChartCaption': 'Sädekaavio',
	'compositeChartCaption': 'Viiva- ja pylväskaavio',
	'wordCloudChartCaption': 'Sanajoukko',
	'networkChartCaption': 'Verkkokaavio',
	'relationshipNetworkChartCaption': 'Suhdeverkkokaavio',
	'treemapChartCaption': 'Rakennekaavio',
	'packedBubbleChartCaption': 'Kuplarykelmäkaavio',
	'hierarcicalPackedBubbleChartCaption': 'Hierarkian kuplakaavio',
	'spiralChartCaption': 'Spiraalikaavio',
	'decisionTreeChartCaption': 'Sääntörakenne',
	'legacyMapChartCaption': 'Vanha kartta',
	'sunburstChartCaption': 'Auringonsädekaavio',
	'visUsageComparison': 'Vertailu',
	'visUsageRelationships': 'Suhteet',
	'visUsageTrend': 'Suuntaus',
	'visUsagePartsToWhole': 'Osien suhde kokonaisuuteen',
	'visUsageGeospatial': 'Paikkatiedot',
	'visUsageAdvanced': 'Edistyksellinen analytiikka',
	'visUsageTablesAndSummary': 'Taulukot ja yhteenveto',
	'visUsageSocialInsights': 'Sosiaalinen oivallustoiminto',
	'visUsageOther': 'Muut',
	'autoBinActionText': 'Automaattinen ryhmittely',
	'filterAutobinActionText': 'Suodata numeroryhmät',
	'memberCalculationActionText': 'Jäsenen laskutoimitus',
	'toolbarActionCalculation': 'Luo laskutoimitus',
	'toolbarActionEditCalculation': 'Muokkaa laskutoimitusta',
	'topBottomRankLabel': 'Luokitus (%{label})',
	'toolbarDeleteFilterActionText': 'Poista suodatin',
	'toolbarActionTopKeyDrivers': 'Näytä vaikuttimet',
	'toolbarActionCustomGroup': 'Mukautettu ryhmä',
	'canNotCreateCustomGroup': 'Tämän mukautetun ryhmän luonti ei onnistu.',
	'aria_label_datatable': 'Tietotaulukko',
	'summaryCaption': 'Yhteenveto',
	'MeasuresCaption': 'Lukuarvot',
	'MeasuresGroupCaption': 'Lukuarvoryhmä (%{count})',
	'ValuesCaption': 'Arvot',
	'turnInsightsOn': 'Ota oivallustoiminto käyttöön',
	'turnInsightsOff': 'Poista oivallustoiminto käytöstä',
	'decisionRules': 'Säännöt',
	'decisionTree': 'Rakennekaavio',
	'decisionSunburst': 'Rakenne-esityksen auringonsädekaavio',
	'switchToDecisionRules': 'Siirry päätössääntöihin',
	'switchToDecisionTree': 'Siirry sääntörakenteeseen',
	'data_group_less_then': 'pienempi kuin %{rangeTo}',
	'data_group_to': '%{rangeFrom} - < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} ja suurempi kuin',
	'nullValueContent': '(ei arvoa)',
	'sum': 'Summa',
	'count': 'Määrä',
	'countdistinct': 'Lukujen määrä',
	'avg': 'Keskitaso',
	'min': 'Vähimmäisarvo',
	'max': 'Enimmäisarvo',
	'automatic': 'Mukautettu',
	'variance': 'Varianssi',
	'stddev': 'Keskihajonta',
	'median': 'Mediaani',
	'calculated': 'Laskettu',
	'none': 'Ei mitään',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Kehotteen arvot',
	'inputLabelPrompt': 'Arvo',
	'inputPlaceholderPrompt': 'Anna arvo',
	'inputInvalidText': 'Syöte ei kelpaa, kun tyyppi on %{dataType}',
	'unSupportedPrompt': 'Kehote ei ole tuettu',
	'missingDataSource': 'Oikeaa tietolähdettä ei löytynyt.',
	'unSupportedPromptType': 'Kehoteskenaario ei ole tuettu.',
	'preAggregateLabel': 'Käytä kehotteen arvoja tietolähteestä',
	'postAggregateLabel': 'Käytä kehotteen arvoja raportissa',
	'preAggregateText': 'Alue käyttää tietolähteen arvoja, ei mittatietotaulussa näkyviä arvoja.',
	'defaultAggregation_count': 'Määrä',
	'defaultAggregation_countdistinct': 'Lukujen määrä',
	'defaultAggregation_max': 'Enimmäisarvo',
	'defaultAggregation_min': 'Vähimmäisarvo',
	'defaultAggregation_avg': 'Keskitaso',
	'defaultAggregation_sum': 'Summa',
	'defaultAggregation_auto': 'Automaattinen (%{aggregationType})',
	'keydriver_average': 'Kokonaiskeskiarvo',
	'keydriver_up_down': 'Korostetut ryhmät, joiden keskiarvot ovat suuria tai pieniä, vaikuttavat tavoitteeseen enemmän. Ryhmät, joiden keskiarvo on epätavallisen suuri tai pieni, vaikuttavat eniten.',
	'keydriver_different': 'Korostettujen ryhmien jakaumat eroavat merkittävästi kokonaisjakaumasta. Nämä ryhmät vaikuttavat tavoitteeseen enemmän.',
	'topOperator': 'Ylhäällä',
	'bottomOperator': 'Alhaalla',
	'topBottomFact': '%{operator} %{value}%{percent} - %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Poista ensimmäisten tai viimeisten lukumäärä',
	'deleteTopBottomPercent': 'Poista ylin tai alin prosenttiosuus',
	'topBottomTitle': 'Vain tämä objekti',
	'deleteTopBottom': 'Poista ensimmäisten tai viimeisten lukumäärä',
	'editTopBottom': 'Muokkaa ensimmäisten tai viimeisten lukumäärää',
	'editTopBottomCount': 'Muokkaa ensimmäisten tai viimeisten lukumäärää',
	'editTopBottomPercent': 'Muokkaa ylintä tai alinta prosenttiosuutta',
	'ariaDeleteTopBottomCountLabel': 'Poista ensimmäisten tai viimeisten lukumäärä painamalla DELETE-näppäintä.',
	'ariaDeleteTopBottomPercentLabel': 'Poista ylin tai alin prosenttiosuus painamalla DELETE-näppäintä.',
	'ariaEditTopBottomCountLabel': 'Muokkaa ensimmäisten tai viimeisten lukumäärää painamalla ENTER-näppäintä.',
	'ariaEditTopBottomPercentLabel': 'Muokkaa ylintä tai alinta prosenttiosuutta painamalla ENTER-näppäintä.',
	'ariaDeleteDrillStateLabel': 'Muokkaa ensimmäisten tai viimeisten lukumäärää painamalla ENTER-näppäintä.',
	'drillUpStateTitle': 'Poraudu ylöspäin',
	'drillDownStateTitle': 'Poraudu alaspäin',
	'ariaEditTopBottomLabel': 'Muokkaa ensimmäisten tai viimeisten lukumäärää painamalla ENTER-näppäintä.',
	'ariaDeleteTopBottomLabel': 'Poista ensimmäisten tai viimeisten lukumäärä painamalla DELETE-näppäintä.',
	'allKeyDriversLabel': 'Automaattinen (kaikki vaikuttimet)',
	'filter_drag_and_drop_single_dock': 'Voit suodattaa vetämällä ja pudottamalla tietoja tähän.',
	'filter_drag_and_drop_all_tabs': 'Voit suodattaa kaikki välilehdet vetämällä ja pudottamalla tietoja tähän.',
	'filter_drag_and_drop_current_tab': 'Voit suodattaa tämän välilehden vetämällä ja pudottamalla tietoja tähän.',
	'filter_empty_consume_mode': 'Käytössä ei ole mitään suodattimia.',
	'filterClearAllItems': 'Tyhjennä kaikki suodattimet',
	'filterDeleteAllItems': 'Poista kaikki suodattimet',
	'filterDockChevronLeft': 'Vieritä tietoja',
	'filterDockChevronRight': 'Vieritä tietoja',
	'filterIconLabel_Single': 'Suodattimet',
	'filterIconLabel_Global': 'Kaikki välilehdet',
	'filterIconLabel_Tab': 'Tämä välilehti',
	'filterIconTooltip_Single': 'Suodattimet',
	'filterIconTooltip_Global': 'Suodattimet kaikille välilehdille',
	'filterIconTooltip_Tab': 'Suodattimet tälle välilehdelle',
	'filterDropZoneTooltip_Single': 'Suodattimen pudotusalue',
	'filterDropZoneTooltip_Global': 'Suodattimen pudotusalue kaikille välilehdille',
	'filterDropZoneTooltip_Tab': 'Suodattimen pudotusalue tälle välilehdelle',
	'filterOverflowMenu': 'Enemmän',
	'expand': 'Laajenna',
	'collapse': 'Tiivistä',
	'filterDockItemNameAriaLabel': 'Aloita suodatinikkuna ja määritä suodatin painamalla Enter-näppäintä.',
	'filterItemCanvasMove': 'Lisää työalueelle',
	'filterItemDelete': 'Poista suodatin',
	'filterInvertRange': 'kaikki paitsi: %{from} - %{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Ei arvon %{from} jälkeen',
	'filter_date_after': 'Arvon %{from} jälkeen',
	'filter_date_before_except': 'Ei ennen arvoa %{to}',
	'filter_date_before': 'Ennen arvoa %{to}',
	'filter_date_between_except': 'Ei väliltä %{from} - %{to}',
	'filter_date_between': 'Väliltä %{from} - %{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Kaikki',
	'filter': 'Suodatin',
	'filterExcept': 'paitsi %{values}',
	'filterDockToolbarButtonLabel': 'Suodatusalue',
	'navigateTitle': 'Siirry kohteeseen',
	'navigateSelectColumn': 'Valitse sarake',
	'navigateSelectPath': 'Valitse siirtymistoiminto',
	'current_nav_group': 'Nykyinen navigointiryhmä on %{navigation_group_name}',
	'next': 'Seuraava',
	'previous': 'Edellinen',
	'multiselectMsg': 'Valittu %{count}',
	'errMsgFilterItemMissingTitle': 'Suodattimen arvoja %{itemName} ei voi ladata, koska arvot eivät ole käytettävissä tämän tietojoukon kanssa',
	'errMsgFilterItemGenericTitle': 'Suodattimen arvojen lataus ei onnistu',
	'textFilterItemsNotFound': 'Kohteita ei ole käytettävissä.',
	'nullValueLabel': '(tyhjä)',
	'filterConditionLabel': 'Suodatusehto',
	'filter_includesAll': 'Sisältää kaikki',
	'filter_allMembersOfSet': 'Kaikki joukon jäsenet',
	'modelFilter': 'Suodatin',
	'filtersTitle': 'Suodattimen ominaisuudet',
	'search': 'Hae',
	'clearTextFilterValue': 'Tyhjennä',
	'invertFilterSelection': 'Muuta käänteiseksi',
	'modellingLoading': 'Ladataan...',
	'searchAll': 'Etsi kaikki sarakkeet',
	'toolbarActionPossibleKeyDrivers': 'Muokkaa aluetta',
	'toolbarActionPossibleKeyDriversSubTitle': 'Vedä vasemmalta kohteet, jotka haluat otettavan huomioon vaikutinanalyysikaaviossa',
	'toolbarActionSort': 'Lajittelu',
	'toolbarActionSortAscending': 'Nouseva',
	'toolbarActionSortDescending': 'Laskeva',
	'toolbarActionSortAuto': 'Automaattinen (%{sortOrder})',
	'toolbarActionSortCustom': 'Mukautettu',
	'toolbarActionFormat': 'Alusta tiedot',
	'toolbarActionFormatText': 'Muotoile tiedot (teksti)',
	'toolbarActionFormatAbbreviation': 'Lyhennä',
	'toolbarActionFormatNone': 'Automaattinen',
	'toolbarActionFilter': 'Suodatin',
	'toolbarActionTopBottom': 'Ylin tai alin',
	'toolbarActionRmvShape': 'Poista muoto',
	'toolbarActionToggleShapeDrop': 'Infografiikan muoto',
	'toolbarActionToggleShapeDropTitle': 'Luo infografiikka',
	'toolbarActionToggleShapeDropText': 'Voit luoda infografiikan vetämällä muodon tähän kenttään.',
	'toolbarActionAggregationType': 'Laske yhteen',
	'toolbarDeleteActionText': 'Poista sarake',
	'toolbarTextActionText': 'Käytä tyyliä tekstissä',
	'toolbarActionFilterLocalKeepSelected': 'Säilytä',
	'toolbarActionFilterLocalExcludeSelected': 'Jätä pois',
	'toolbarActionFilterAllKeepSelected': 'Suodatin',
	'toolbarActionSimpleCalculation': 'Yksinkertainen laskutoimitus',
	'toolbarActionDrillBack': 'Edellinen',
	'toolbarActionDrillUp': 'Poraudu ylöspäin',
	'toolbarActionDrillDown': 'Poraudu alaspäin',
	'toolbarActionJumpTo': 'Porautuminen',
	'toolbarActionNavigate': 'Siirry',
	'toolbarActionCreateFilterGroup': 'Luo uusi yhteys',
	'toolbarActionDisconnectFilterGroup': 'Katkaise kaikki linkit',
	'toolbarActionLinkFilterGroup': 'Lisää aiemmin luotuun yhteyteen',
	'toolbarActionLassoSelect': 'Valitse työkalu',
	'toolbarActionRefreshDeveloperWidget': 'Päivitä',
	'textFontFamilySubClassHairline': 'Hiusviiva',
	'textFontFamilySubClassThin': 'Ohut',
	'textFontFamilySubClassThinItalic': 'Ohut kursivoitu',
	'textFontFamilySubClassExtraLight': 'Hyvin ohut',
	'textFontFamilySubClassExtraLightItalic': 'Hyvin ohut kursivoitu',
	'textFontFamilySubClassLight': 'Ohuehko',
	'textFontFamilySubClassLightItalic': 'Ohuehko kursivoitu',
	'textFontFamilySubClassRegular': 'Normaali',
	'textFontFamilySubClassRegularItalic': 'Tavallinen kursivoitu',
	'textFontFamilySubClassItalic': 'Kursivoitu',
	'textFontFamilySubClassMedium': 'Keskikokoinen',
	'textFontFamilySubClassMediumItalic': 'Keskikokoinen kursivoitu',
	'textFontFamilySubClassHeavy': 'Paksu',
	'textFontFamilySubClassHeavyItalic': 'Paksu kursivoitu',
	'textFontFamilySubClassDemiBold': 'Puolilihavoitu',
	'textFontFamilySubClassDemiBoldItalic': 'Puolilihavoitu kursivoitu',
	'textFontFamilySubClassBold': 'Lihavoitu',
	'textFontFamilySubClassBoldItalic': 'Lihavoitu ja kursivoitu',
	'textFontFamilySubClassExtraBold': 'Hyvin paksu',
	'textFontFamilySubClassExtraBoldItalic': 'Hyvin paksu kursivoitu',
	'textFontFamilySubClassBlack': 'Musta',
	'textFontFamilySubClassBlackItalic': 'Musta kursivoitu',
	'textFontFamilySubClassStencil': 'Stencil-fontti',
	'dlg_ascending': 'nouseva',
	'dlg_descending': 'laskeva',
	'dlg_custom': 'mukautettu',
	'dlg_none': 'ei mitään',
	'dlg_hierarchy': 'hierarkia',
	'dlg_namedSet': 'nimetty joukko',
	'dlg_rank': 'rank',
	'visualizationLabel': 'Visualisointi',
	'chartLabel': 'Kaavio %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Siirry pienoisohjelmassa painamalla F12-näppäintä',
	'f10KeyDescription': 'Avaa pienoisohjelman tarkastelunäkymä painamalla F10-näppäintä',
	'playButtonLabel': 'Toista',
	'dataPlayerValueListLabel': 'Tietojen toistimen arvot',
	'localFilterTitle': 'Vain tämä objekti',
	'globalFilterTitle': 'Kaikki objektit',
	'deleteFilter': 'Poista suodatin',
	'editFilter': 'Muokkaa suodatinta',
	'ariaEditFilterLabel': 'Muokkaa suodatinta painamalla ENTER-näppäintä.',
	'ariaDeleteFilterLabel': 'Poista suodatin painamalla DELETE-näppäintä.',
	'measureFilterBetween': 'Väliltä %{lowerBound} - %{upperBound}',
	'measureFilterNotBetween': 'Ei väliltä %{lowerBound} - %{upperBound}',
	'dimFilterIn': 'Sisältää: %{in}',
	'dimFilterNotIn': 'Ei sisällä: %{out}',
	'gtFilter': 'Arvon %{lowerBound} jälkeen',
	'ltFilter': 'Ennen arvoa %{upperBound}',
	'ariaEditPrompt': 'Muuta kehotearvoa painamalla ENTER-näppäintä',
	'dataPointFilterTitle': 'Tietopisteet',
	'dataPointFilterIncludeSummary': 'Sisällytetyt tietopisteet: %{valueCount}',
	'dataPointFilterExcludeSummary': 'Pois jätetyt tietopisteet: %{valueCount}',
	'widgetFiltersLabel': 'Pienoisohjelman suodattimet',
	'coachMarkTitleSpiralTarget': 'Muokkaa aluetta',
	'coachMarkContentSpiralTarget': 'Tässä voit käyttää ja muokata vaikuttimien valintaa kohdetta varten.',
	'srILVTreeLabel': 'Luettelo',
	'geomapUnrecognizedLocations': 'Tuntemattomat sijainnit:',
	'geomapAmbiguousLocations': 'Monitulkintaiset alueet:',
	'visualizationNotifications': 'Visualisoinnin ilmoitukset:',
	'dataNotifications': 'Tietoilmoitukset:',
	'autobinSuggestion': 'Ota automaattinen ryhmittely käyttöön',
	'LIVE_empty_visualization_hint_title': 'Visualisointien muodostus',
	'LIVE_empty_visualization_hint_description': 'Vedä tiedot tähän tai kenttiin.',
	'LIVE_slots_required_field_description': '%{asterisk} ilmaisee pakollisen kentän',
	'LIVE_slots_drag_and_drop_description': 'Voit muodostaa visualisoinnin ja suodattaa sen vetämällä ja pudottamalla tiedot yllä oleviin kenttiin.',
	'dwErrorLoadingAvailableVisualizations': 'Käytettävissä olevien visualisointimääritysten lataus ei onnistu',
	'moreDataIndicator': 'Tiedot on leikattu %{threshold} kohteen jälkeen. Näytä vähemmän tietoja suodattamalla.',
	'nonCtxTopBottomInvalid': 'Kontekstiton Ylimmät/alimmat-sääntö ei ole tuettu ristiintaulukoinneissa. Sääntö on poistettu tästä ristiintaulukointinäkymästä.  Määritä sääntö uudelleen yhdessä tai useammassa kontekstin {columnName} luokassa.',
	'dwErrorLoadingVisualizationNotFound': 'Objektin lataus ei onnistu, koska siitä puuttuu visualisointimääritys.',
	'dwErrorLoadingVisualizationListNotFound': 'Visualisoinnin lataus ei onnistu.',
	'dwErrorRunningQuery': 'Tietojen nouto tietojoukosta %{datasetName} ei onnistu.',
	'dwErrorGeoData': 'Maantieteellisten tietojen näyttämisessä kartalla on ongelma. Valitse toinen visualisointityyppi.',
	'dwPromptSignonCancelWarning': 'Tämän visualisoinnin tiedot eivät ole käytettävissä. Anna kelvolliset valtuustiedot.',
	'dwErrorMissingDataset': 'Visualisoinnin lataus ei onnistu, koska siihen liittyvä tietojoukko %{datasetName} ei ole käytettävissä.',
	'dwErrorRenderingVisualization': 'Visualisoinnin lataus ei onnistu.',
	'dwErrorVisualizationTooSmall': 'Visualisointi on liian pieni. Se ei voi näyttää sisältämiään tietoja. Suurenna visualisointia tai rajoita sen sisältämiä tietoja.',
	'errorSourceNotFound': 'Visualisoinnin lataus ei onnistu, koska siihen liittyvä tietojoukko %{sourceName} ei ole käytettävissä.',
	'errorActionNotSupported': 'Tämä toiminto ei ole tuettu tietolähteessä %{sourceName}.',
	'errorMeasureNotSupportedOnMultiEdges': 'Visualisoinnissa on lukuarvoja usealla reunalla. Tämä ei ole enää tuettua. Sijoita lukuarvoja vain yhdelle reunalle.',
	'errorExceedAllowableValue': 'Solujen arvioitu määrä on suurempi kuin sallittu 100 000. Vähennä solujen määrää suodattamalla projisoitavia joukkoja.',
	'propScaleLabel': 'Kuvakkeiden määrä',
	'propScaleDescription': 'Valitse kuvakkeiden määrä',
	'propScaleFew': 'Pieni',
	'propScaleDefault': 'Oletus',
	'propScaleMany': 'Suuri',
	'lastRefresh': 'Päivitetty viimeksi: %{timeInterval} sitten',
	'widgetTimer': 'Pienoisohjelman ajastin',
	'datasetItemsUnavailable': 'Jotkin tässä visualisoinnissa käytetyt tietojoukkojen kohteet eivät ole käytettävissä.',
	'datasetItemUnavailable': 'Tämä tietojoukon kohde ei ole käytettävissä',
	'retry': 'Yritä uudelleen',
	'widgetConditionalFormatLabel': 'Vaihda ehdollisen muotoilun ohjausobjektit',
	'widgetConditionalFormatTitle': 'Ehdollisen muotoilun värin muokkaus',
	'crosstabName': 'Ristiintaulukointi',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Ei käytettävissä',
	'summaryLabel': '%{label}, jonka arvo on %{value}',
	'infographicLabel': '%{label}, jonka arvo on %{value}',
	'warning': 'Varoitus',
	'swapRowsAndColumns': 'Vaihda rivit ja sarakkeet',
	'hideSummariesLabel': 'Piilota summat',
	'showSummariesLabel': 'Näytä summat',
	'hideRowColumn': 'Piilota',
	'showAllRowColumn': 'Näytä kaikki',
	'dataAssetPropertiesLabel': 'Visualisoinnin ominaisuudet',
	'evAdd': 'Lisää sarake',
	'evCollapse': 'Tiivistä',
	'evColumns': 'Sarakkeet',
	'evLocalFilters': 'Paikalliset suodattimet',
	'evExpand': 'Laajenna',
	'evFilterTooltip': 'Suodatin',
	'missingColumn': 'Puuttuva: %{columnLabel}',
	'missingFiltering': 'Sarakkeista puuttuvat suodattimet:',
	'missingDataItem': 'Viitattua tietoalkiota %{dataItemId} ei löydy pienoisohjelmasta.',
	'heatByLabel': 'Lämmön peruste',
	'toolbarChangeVisualization': 'Vaihda visualisointi',
	'modellingRelatedTablesNoneFound': 'Liittyviä taulukoita ei löytynyt',
	'processing': 'Käsitellään...',
	'errorCellWarning': 'Joidenkin kokonaissumman arvojen laskenta ei onnistunut.',
	'aggregateTypeToggler': 'Näytä yhdistämistyyppi',
	'maxColumnsExceeded': 'Sarakkeiden enimmäismäärä on ylittynyt. %{columns} on hylätty.',
	'unboundColumns': 'Seuraavien sarakkeiden käyttö ei onnistu: %{columns}.',
	'unboundColumn': 'Seuraavan sarakkeen käyttö ei onnistu: %{columns}.',
	'recommendRequestFailed': 'Suosituspyyntö epäonnistui. Ota yhteys pääkäyttäjään.',
	'visualizationDoesNotSupportOLAP': 'Tämän OLAP-tietolähteeseen perustuvan visualisoinnin luonti ei onnistu. Käytä jotakin muuta tuettua tietolähdettä.',
	'showDataBehindVizLabel': 'Näytä tiedot',
	'showDataBehindVizNotSupportedLabel': 'Näytä tiedot -vaihtoehto ei ole tuettu tässä visualisointityypissä',
	'exploreData': 'Selaa...',
	'newExplore': 'Uusi tutkimus',
	'thumbnails_error_fetching': 'Pienoiskuvien noudossa on ilmennyt virhe.',
	'loadedThumbnailImage': 'Visualisoinnin %{visType} pienoiskuva on ladattu.',
	'autobinAxisLabel': 'ryhmät',
	'recommended_visualizations': 'Suositellut visualisoinnit',
	'all_visualizations': 'Kaikki visualisoinnit',
	'edit': 'Muokkaa',
	'selectTargetDialogTitle': 'Porautumiskohteen valinta',
	'noTargetInCM': 'Porautumiskohdetta ei löydy',
	'errorDrillDefinition': 'Lisättäessä tai muokattaessa porautumismääritystä on ilmennyt virhe.',
	'errorDrillToTarget': 'On ilmennyt virhe porauduttaessa kohteeseen %{targetName}',
	'drillThroughMappingViewLabel': 'Määritä mittatietotaulussa olevia sarakkeita kohderaportin kehotteisiin',
	'drillthroughScopeRadioLabel': 'Tämän määrityksen käyttöalue:',
	'drillthroughScopeRadioOptionVisualization': 'Vain tämä visualisointi',
	'drillthroughScopeRadioOptionConnection': 'Saman yhteyden samaa tietolähdettä käyttävät visualisoinnit',
	'drillthroughScopeRadioOptionDashboard': 'Kohteen %{perspective} mikä tahansa visualisointi, joka käyttää samaa tietolähdettä',
	'drillThroughParametersColumnTitle': 'Kohteen %{targetName} kehotteet:',
	'drillThroughMetadataColumnTitle': 'Kohteen %{boardName} tietosarakkeet:',
	'drillThroughDefinitionNoParameter': 'Porautumiskohteessa ei ole kehotteita.',
	'drillThroughDefinitionErrorQueryingReport': 'Korjaa kohderaporttiin liittyvä ongelma. Yritä sitten luoda porautumismääritys uudelleen.',
	'drillThroughDefinitionErrorDlgTitle': 'On ilmennyt virhe',
	'dlg_back': 'Takaisin',
	'dlg_close': 'Sulje',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Peruuta',
	'dlg_apply': 'Käytä',
	'dlg_create': 'Luo',
	'dlg_done': 'Valmis',
	'drillthrough_unsaveMsg': 'Haluatko jatkaa tallentamatta kohdetta %{name}?',
	'drillthrough_jumpTo': 'Porautumismääritys: %{name}',
	'drillthrough_jumpToLabel': 'Porautuminen',
	'drillthrough_manage': 'Hallitse...',
	'drillthrough_addNewTarget': 'Lisää uusi porautumismääritys',
	'drillthrough_manageJumpPaths': 'Hallitse porautumismäärityksiä',
	'drillthrough_manageJumpPaths_edit': 'Muokkaa kohdetta %{name}',
	'drillthrough_manageJumpPaths_delete': 'Poista %{name}',
	'drillthrough_manageAddAnotherTarget': 'Lisää toinen porautumismääritys',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Vahvista poisto',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Haluatko varmasti poistaa porautumisen %{name}?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Päällekkäinen porautumisen nimi',
	'drillthrough_definitionMessage': 'Porautuminen %{name} on jo järjestelmässä. Anna toinen nimi',
	'drillthrough_jumpToTarget_notFound': 'Porautumisen %{name} kohdetta ei löytynyt',
	'drillThroughDefinitionNoParameterSubTitle': 'Kohderaporttiin ei välitetä tekstiä.',
	'drillthrough_titleLabel': 'Nimi',
	'drillthrough_create_dialogTitle': 'Luo porautumismääritys',
	'drillthrough_edit_dialogTitle': 'Muokkaa porautumismääritystä',
	'drillthrough_subTitle': 'Lähteessä olevan visualisoinnin kontekstia käytetään kohteen %{perspective} suodatukseen.',
	'drillthrough_selectColumn': 'Valitse sarake',
	'noPrompt': 'Ei kehotteita',
	'promptDialog': 'Kohteen %{promptType} kehoteikkuna',
	'formatAutoDescription': 'Vaihtoehto Automaattinen määrittää tietolähteestä tai visualisoinnista perityn muodon',
	'formatDefaultDescription': 'Vaihtoehto Oletus määrittää järjestelmästä perityn muodon',
	'createCustomGroupAction': 'Luo tietoryhmä',
	'removeCustomGroupAction': 'Poista tietoryhmä',
	'editCustomGroupAction': 'Muokkaa tietoryhmää',
	'renameCustomGroupAction': 'Nimeä tietoryhmä uudelleen',
	'createCustomGroupErrorToast': 'Tietoryhmän luonti ei onnistunut.',
	'removeCustomGroupErrorToast': 'Tietoryhmän poisto ei onnistunut.',
	'editCustomGroupErrorToast': 'Tietoryhmän muokkaus ei onnistunut.',
	'renameCustomGroupErrorToast': 'Tietoryhmän uudelleennimeäminen ei onnistunut.',
	'customGroupLabel': 'Luo tietoryhmä',
	'ungroupCustomGroupLabel': 'Pura ryhmä',
	'renameCustomGroupLabel': 'Nimeä uudelleen',
	'createCustomGroupLabel': 'Luo',
	'customGroupingLabel': '%{columnLabel} (ryhmä)',
	'createCustomSort': 'Luo mukautettu lajittelu',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Valitse käytettävissä olevat kohteet ja luo sitten mukautettu lajittelu järjestämällä kohteet uudelleen.',
	'availableItems': 'Käytettävissä olevat kohteet',
	'selectAll': 'Valitse kaikki',
	'customSortOrder': 'Mukautettu lajittelujärjestys',
	'selectAvailableItemsDesc': 'Valitse käytettävissä olevat kohteet ja järjestä ne tässä uudelleen.',
	'moveToTop': 'Siirrä ylimmäksi',
	'clear': 'Tyhjennä',
	'sortRemainingItemsBy': 'Lajittele jäljellä olevat kohteet seuraavalla perusteella',
	'removeAll': 'Poista kaikki',
	'resetTooltip': 'Kaikki kohteet poistetaan luettelosta %{customSortOrder}. Lisäksi avattava luettelo %{sortRemainingItemsBy} palautuu oletusarvon mukaiseksi.',
	'manyItemsWarning': 'Usean kohteen valinta voi vaikuttaa mittatietotaulun suorituskykyyn.',
	'manyItemsSelected': 'On valittu enemmän kuin %{maxItems} kohdetta, mikä voi heikentää mittatietotaulun suorituskykyä.',
	'somethingWentWrong': 'On ilmennyt jokin ongelma.',
	'tryAgain': 'Yritä uudelleen',
	'customSortLabel': 'Mukautettu lajittelu',
	'applyError': 'Kohteen %{action} käyttö ei onnistu.',
	'searchReturnedNoResults': 'Haku ei palauttanut tuloksia.',
	'extVisSystem': 'Järjestelmä',
	'extVisCustom': 'Mukautettu',
	'customVisTestVisualization': 'Testaa visualisointia',
	'extVisCustomVisPreview': 'esikatselu',
	'extVisCustomPreviewWidgets': 'Kehittäjän pienoisohjelmat',
	'extVisCustomVVisualization': 'Visualisointi',
	'extVisCustomVisuals': 'Mukauta visualisointia',
	'noPermissionToManage': 'Sinulla ei ole mukautettujen visualisointien hallintaoikeuksia.',
	'extVisCustomUpdate': 'Päivitä',
	'extVisCustomDelete': 'Poista',
	'extVisNoCustomVisuals': 'Ei mukautettuja visualisointeja',
	'extVisNoCustomVisualsMsg': 'Organisaatiossasi ei ole tällä hetkellä mukautettuja visualisointeja.',
	'extVisAddCustomVisual': 'Lisää mukautettu visualisointi',
	'extVisNoCustomVisualsAdminMsg': 'Järjestelmässä ei ole nyt mukautettuja visualisointeja. Aloita lisäämällä yksi.',
	'extVisNoSDKConnection': 'Paikalliseen tiedostoon ei ole luotu yhteyttä.',
	'extVisNoSDKPreviewMsg': 'Voit esikatsella visualisointia muodostamalla ensin yhteyden.',
	'extVisMore': 'Enemmän',
	'extVisDeleteDialogTitle': 'Poista mukautettu visualisointi',
	'extVisDeleteDialogBody': 'Haluatko varmasti poistaa tämän mukautetun visualisoinnin? Tämä saattaa olla käytössä muissa mittatietotauluissa ja raporteissa.',
	'extVisDeleteConfirmation': 'Mukautettu visualisointi on poistettu.',
	'extVisDeleteError': 'Mukautetun visualisoinnin poisto ei onnistunut. %{msg}',
	'extVisCloseToast': 'Sulje nyt',
	'extVisAdd': 'Mukautettu visualisointi on lisätty.',
	'extVisAddError': 'Mukautetun visualisoinnin lisäys ei onnistunut. %{msg}',
	'extVisUpdate': 'Mukautetun visualisoinnin päivitys on onnistunut.',
	'extVisUpdateError': 'Mukautetun visualisoinnin päivitys ei onnistunut. %{msg}',
	'extVisAddProgress': 'Kohteen %{name} tuonti on meneillään',
	'extVisUpdateProgress': 'Kohteen %{name} päivitys on meneillään',
	'extPermissionTitle': 'Poistettu mukautettu visualisointi tai sen käyttöä on rajoitettu',
	'extPermissionBody': 'Tätä mukautettua visualisointia ei voi tarkastella, koska se on joko poistettu tai sen käyttöä on rajoitettu.',
	'customVizSaveWarning': 'Mukautettujen visualisointien tallennus ei onnistu. Niitä ei ole tuotu.',
	'schematicTestCaption': 'Testaa skematiikkaa',
	'schematicServiceRequestError': 'Skematiikkapalvelun virhe',
	'extVisPreviewMessage': 'Tämä on esikatselunäkymä. Visualisointia ei ole vielä lisätty tuotteeseen.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Määrittämätön',
	'kpiDefaultTargetLabel': 'Tavoite',
	'kpiNonNumericTarget': 'Kohteen arvon tulee olla luku.',
	'kpiManualTargetSlotFilled': 'Kentässä käyttävä arvo',
	'kpiAutoValueSize': 'Automaattinen',
	'kpiUnableDrawSparklineLabel': 'Pienoiskaavion piirtäminen ei onnistu',
	'kpiUnableDrawSparklineInfo': 'Pienoiskaavio tarvitsee vähintään kaksi ajankohtaa. Muuta tietoja tai säädä suodattimia, jotta saat pienoiskaavion näkyviin.',
	'conditionalFormattingTextColor': 'Tekstin väri',
	'suppression': 'Piilotus',
	'suppressNone': 'Ei mitään',
	'suppressRowsAndColumns': 'Rivit ja sarakkeet',
	'suppressRows': 'Rivit',
	'suppressColumns': 'Sarakkeet',
	'enableSuppression': 'Ota piilotus käyttöön',
	'disableSuppression': 'Poista piilotus käytöstä',
	'loadVisDefinitionError': 'Visualisoinnin %{id} määrityksen lataus ei onnistu',
	'emptyVisualization': 'Tyhjä visualisointi',
	'expandCollapse': 'Laajenna ja tiivistä',
	'expandBtnLabel': 'Laajenna',
	'collapseBtnLabel': 'Tiivistä',
	'prop_sizeInputNonNumericValue': 'Arvon on oltava numero.',
	'prop_sizeValueShouldBeHigher': 'Arvon on oltava suurempi kuin %{value}.',
	'fontPropLabel': 'Fonttiperhe',
	'fontSizePropLabel': 'Fonttikoko',
	'sectionItemAxisTitle': 'Kohdeakselin otsikko',
	'sectionItemAxisLabel': 'Kohdeakselin nimiö',
	'sectionValueAxisTitle': 'Arvoakselin otsikko',
	'sectionValueAxisLabel': 'Arvoakselin nimiö',
	'styletext-widget.legend': 'Selite',
	'styletext-itemAxis.ticks.labels': 'Akselin nimiö',
	'styletext-valueAxis.title': 'Akselien otsikot',
	'styletext-itemAxis.title': 'Akselien otsikot',
	'styletext-labels': 'Tietojen nimiöt',
	'styletext-valueAxis.line.title': 'Viivojen otsikot',
	'styletext-cellValue': 'Arvot',
	'styletext-values': 'Arvot',
	'styletext-rowHeading': 'Rivien otsikot',
	'styletext-columnHeading': 'Sarakeotsikot',
	'fontFamily': 'perhe',
	'fontSize': 'koko',
	'visExportFileName': 'Visualisointi',
	'ds-missingDataSet': 'Tietojoukkoa ei löytynyt. Varmista, että tietojoukon luonti on onnistunut.',
	'ds-missingDashboardId': 'Tallenna mittatietotaulu ennen tietojoukon luontia.',
	'ds-unsupportedDataSourceType': 'Tietolähteen tyyppi %{type} ei ole tuettu.',
	'dataCache': 'Datavälimuisti',
	'dataCache_on': 'Käytössä',
	'dataCache_off': 'Ei tallennusta välimuistiin',
	'dataCache_auto': 'Automaattinen',
	'queryOptimization': 'Kyselyjen optimointi'
});
